import styled, { css } from 'styled-components';
import { PillCustomWrapper } from '@/app/common/components/Pill/styled.ts';

export const FloatingLayoutContainer = styled.div<{ isDark?: boolean; evolutionEnabled?: boolean }>`
  display: flex;
  border-radius: 24px;

  ${PillCustomWrapper} {
    color: inherit;
    position: relative;

    &:after {
      content: '';
      width: 1px;
      background-color: ${({ theme }) => theme.kallisto.color.text.static.textSecondary};
      height: 20px;
      display: block;
      position: absolute;
      left: 100%;
      top: 10px;
    }

    &:last-child {
      &:after {
        content: unset;
      }
    }

    [class*='PillWrapper'] {
      [class*='Pill__Label'] {
        position: relative;
        overflow: initial;
        ${({ theme }) => theme.kallisto.mixins.font('BodySmall')};
        font-weight: bold;

        .counter {
          top: 0;
          right: unset;
          left: 18px;
        }
      }
    }

    ${({ evolutionEnabled }) =>
      evolutionEnabled
        ? css`
            &.pill-all-filters:not(.selected) [class*='PillWrapper'] {
              border: 0;
            }
          `
        : css`
            [class*='PillWrapper'] {
              color: inherit;
              border: 0;
            }
          `}
  }

  ${({ isDark, theme }) =>
    isDark
      ? css`
          background-color: ${theme.kallisto.color.text.static.textPrimary};
          color: white;

          && ${PillCustomWrapper}:not([data-loading]) [class*='PillWrapper'] {
            background-color: transparent;
            border: 0;
            box-shadow: none;
            color: inherit;

            &:hover {
              background-color: transparent;
              border: 0;
              box-shadow: none;
              color: inherit;
            }

            > svg {
              fill: white;
            }

            [class*='Pill__Label'] span {
              color: inherit;
            }
          }
        `
      : css`
          background-color: ${theme.kallisto.color.common.white['1000']};
          box-shadow: 0 2px 8px rgba(0, 0, 0, 0.15);
        `};
`;
